export default function useDevice(initialUa?: string) {
    // ✅ Get headers server-side
    const headers = import.meta.server ? useRequestHeaders() : undefined;

    // ✅ user agent: from initial param / server headers / navigator on client
    const ua = initialUa || headers?.["user-agent"] || (import.meta.client ? navigator.userAgent : "");

    const type = ref(detectDevice(ua));

    const isMobile = computed(() => type.value === "mobile");
    const isTablet = computed(() => type.value === "tablet");
    const isDesktop = computed(() => type.value === "desktop");

    return { type, isMobile, isTablet, isDesktop };
}
